<template>
<div class="acomodar">
    <MesadAyuda/>
</div>
</template>

<script>
import MesadAyuda from '@/components/MesadAyuda.vue';
export default {
  name: 'SeguimientodeSolicitud',
  components: {
    MesadAyuda
  },
  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>
<style  scoped>

</style>